export const formatDateString = (dateString) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // Split the input string
    const [month, day, year] = dateString.split("-").map(Number);
    
    // Format the output
    return `${months[month - 1]} ${day}, ${year}`;
}

export const formatDateDelimiter = (dateString, delimiter) => {
    return dateString.replaceAll('-', delimiter);
}

export const darkenColor = ({ r, g, b }, factor) => {
    return `rgb(${Math.max(0, r - factor * 255)}, ${Math.max(0, g - factor * 255)}, ${Math.max(0, b - factor * 255)})`;
};

export const darkenColorString = (rgbaColorString, factor) => {
    const rgbaValues = rgbaColorString.match(/\d+(\.\d+)?/g); // Extracts numbers
    const r = parseInt(rgbaValues[0], 10);
    const g = parseInt(rgbaValues[1], 10);
    const b = parseInt(rgbaValues[2], 10);

    return darkenColor({r, g, b}, factor);
}

export const lightenColor = ({ r, g, b }, factor) => {
    return `rgb(${Math.min(255, r + factor * 255)}, ${Math.min(255, g + factor * 255)}, ${Math.min(255, b + factor * 255)})`;
}